
import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilterFormAttributeByKey, getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import {setUpListObserver} from "@/helpers/filter/filter-list-helper";
import $ from "jquery";
import selectize from "@selectize/selectize"
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";

export class LayerInfoFilterSettingsListMultiComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const formAttribute = getActiveFilterFormAttributeByKey(key)

        const template = document.createElement('template');
        template.innerHTML = `<select style="width:100%" size="1" multiple="multiple"></select>`;

        initWebComponent(this, template)

        setUpListObserver(this, formAttribute, true)
    }
}
